export default __webpack_public_path__ + "static/media/arrowRight.fd457af9.svg";